import { DEFAULT_PAGE_SIZE } from '@w7/ui'
import { apiFetch } from '@/api/client'
import type {
  BetfairRatesLogQuery,
  BetfairRatesLogResult,
  BetfairRatesLogRow,
} from '@/features/logs/betfairRatesTypes'

/** Agent-API `POST /v1/betfair-rates-logs/getBetfairRatesLogs` request. */
export type GetBetfairRatesLogsRequest = {
  page?: number
  pageSize?: number
}

/** One Lab/Agent-API BetfairRates log row (Winner + Backend-UI fields). */
export type BetfairRatesLogApiRow = {
  id: string
  fromUsername?: string
  toUsername?: string
  parentUsername?: string
  username?: string
  game?: string
  percent?: number | string
  oldPercent?: number | string
  minBet?: number | string
  oldMinBet?: number | string
  clientIp?: string
  ip?: string
}

/** Lab/Winner callback envelope from hierarchy-service. */
export type GetBetfairRatesLogsResponse = {
  value: boolean
  data: {
    dataArray: BetfairRatesLogApiRow[]
    totalCount: number
    limit: number
    noOfPages?: number
    page: number
  }
}

/**
 * Lab `BetfairRatesLogs/getBetfairRatesLogs` → Agent-API hierarchy.
 * Returns the raw envelope; map with `toBetfairRatesLogResult`.
 */
export async function getBetfairRatesLogs(
  body: GetBetfairRatesLogsRequest = {},
): Promise<GetBetfairRatesLogsResponse> {
  return apiFetch<GetBetfairRatesLogsResponse>(
    '/v1/betfair-rates-logs/getBetfairRatesLogs',
    {
      method: 'POST',
      body: JSON.stringify({
        page: body.page ?? 1,
        pageSize: body.pageSize ?? DEFAULT_PAGE_SIZE,
      }),
    },
  )
}

/** Map hierarchy rows → console BetfairRates Logs table. */
export function toBetfairRatesLogResult(
  live: GetBetfairRatesLogsResponse,
  query: BetfairRatesLogQuery = {},
): BetfairRatesLogResult {
  const pageSize = live.data?.limit ?? query.pageSize ?? DEFAULT_PAGE_SIZE
  const page = live.data?.page ?? query.page ?? 1
  const total = live.data?.totalCount ?? 0
  const rows: BetfairRatesLogRow[] = (live.data?.dataArray ?? []).map((row) => ({
    id: String(row.id),
    fromUsername: row.fromUsername ?? row.parentUsername ?? '',
    toUsername: row.toUsername ?? row.username ?? '',
    game: row.game ?? '',
    percent: row.percent ?? '',
    oldPercent: row.oldPercent ?? '',
    minBet: row.minBet ?? '',
    oldMinBet: row.oldMinBet ?? '',
    clientIp: row.clientIp ?? row.ip ?? '',
  }))
  return { rows, total, page, pageSize }
}
